import React, { useEffect, useState } from "react";
import { Form, Input, Button, Icon, Tooltip, Popconfirm, message } from "antd";
import { GstConfig } from "../../../../../models";
import {
  generate_query_set,
  handleApiExceptions,
} from "../../../../../app_methods";

let GstConfigForm = (props) => {
  const { form } = props;
  const { getFieldDecorator } = form;
  const validations = GstConfig.validations;

  const [IsTableLoading, setIsTableLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [deletingId, setDeletingId] = useState();
  const [formValues, setFormValues] = useState([{ gstin: "", business_name: "" }]);

  const fetchList = async () => {
    setIsTableLoading(true);
    const response = await GstConfig.list();
    if (!response.success) {
      setIsTableLoading(false);
      handleApiExceptions(response);
      return;
    }
    if (response.data.results.length) {
      setFormValues(generate_query_set(GstConfig, response.data.results));
      form.setFieldsValue({
        gst_config: response.data.results.map((x) => ({
          gstin: x.gstin,
          business_name: x.business_name,
        })),
      });
    } else {
      const results = [{ gstin: "", business_name: "" }]
      setFormValues(generate_query_set(GstConfig, results));
      form.setFieldsValue({
        gst_config: results.map((x) => ({
          gstin: x.gstin,
          business_name: x.business_name,
        })),
      });
    }
    setIsTableLoading(false);
  };

  const _delete = async (gstconfig) => {
    setDeletingId(gstconfig.id);
    const response = await gstconfig.delete();
    if (!response.success) {
      setDeletingId(undefined);
      handleApiExceptions(response);
      return;
    }
    setDeletingId(undefined);
    fetchList();
  };

  useEffect(() => {
    fetchList();
  }, []);

  let addFormFields = () => {
    setFormValues([...formValues, { id: "", gstin: "", business_name: "" }]);
  };

  let removeFormFields = (item, index) => {
    let newFormValues = [...formValues];
    if (item.uuid) {
      _delete(item);
    } else {
      newFormValues.splice(index, 1);
      setFormValues(newFormValues);
    }
  };

  const create = async (data) => {
    setIsSaving(true);
    const response = await GstConfig.create(data);
    if (!response.success) {
      setIsSaving(false);
      handleApiExceptions(response);
      return;
    }
    message.success('GSTIN has been added successfully.');
    setIsSaving(false);
    fetchList();
  };

  const onSubmit = (e) => {
    e.preventDefault();
    form.validateFields((err, values) => {
      if (err) return;
      create(values);
    });
  };

  return (
    <Form onSubmit={onSubmit}>
      <div>
        {formValues.map((item, index) => {
          return (
            <>
              <div key={index} className="row">
                {getFieldDecorator(`gst_config[${index}]['id']`, {
                  initialValue: item.uuid,
                })(<Input hidden />)}

                <div className="col-6">
                  <Form.Item className="mb-0" label={!index && `GSTIN:`}>
                    {getFieldDecorator(`gst_config[${index}]['gstin']`, {
                      initialValue: item.gstin,
                      rules: validations.gstin
                    })(
                      <Input
                        readOnly={item.uuid}
                        autoComplete="off"
                        prefix={<Icon type="profile" />}
                      />
                    )}
                  </Form.Item>
                </div>
                <div className="col-6 pl-0">
                  <div className="d-flex align-items-center">
                    <Form.Item
                      className="mb-0"
                      label={!index && `Business Name:`}
                    >
                      {getFieldDecorator(
                        `gst_config[${index}]['business_name']`,
                        {
                          initialValue: item.business_name,
                          rules:validations.business_name
                        }
                      )(
                        <Input
                          readOnly={item.uuid}
                          autoComplete="off"
                          prefix={<Icon type="mail" />}
                        />
                      )}
                    </Form.Item>
                    {item.id ? (
                      <Popconfirm
                        title="Are you sure you want to remove this GSTIN?"
                        okText="Remove"
                        okType="danger"
                        onConfirm={() => removeFormFields(item, index)}
                      >
                        <Icon
                          className={!index && `mt-4`}
                          style={{
                            color: "rgb(211 19 29)",
                            fontSize: 22,
                            paddingLeft: 15,
                          }}
                          type={deletingId == item.id ? 'loading' : 'delete'}
                        />
                      </Popconfirm>
                    ) : formValues.length > 1 ? (
                      <Tooltip title="Remove GSTIN" placement="right">
                        <Icon
                          className={!index && `mt-4`}
                          style={{
                            color: "rgb(211 19 29)",
                            fontSize: 22,
                            paddingLeft: 15,
                          }}
                          onClick={() => removeFormFields(item, index)}
                          type="delete"
                        />
                      </Tooltip>
                    ) : <Icon
                      className={!index && `mt-4`}
                      style={{
                        color: "rgb(235 176 179)",
                        fontSize: 22,
                        paddingLeft: 15,
                      }}
                      type="delete"
                    />}
                  </div>
                </div>

                {/* <div className="col-1 mb-2 d-flex align-items-center">
                  <Button
                  icon="delete" type="danger" ghost style={{width: 50}}   />
                </div> */}
              </div>
            </>
          );
        })}

        <div
          style={{
            justifyContent: "flex-start",
            display: "flex",
          }}
        >
          <Button
            type="link"
            onClick={() => {
              addFormFields();
            }}
            className="pl-0"
          >
            <Icon type="plus" />
            Add more
          </Button>
        </div>

        <div className="w-100 d-flex justify-content-end mt-4">
          <Button type="primary" htmlType="submit" disabled={IsTableLoading || deletingId} loading={isSaving}>
            Submit
          </Button>
        </div>
      </div>
    </Form>
  );
};

GstConfigForm = Form.create()(GstConfigForm);
export default GstConfigForm;
